// Generated by test/crystal-wings/export.py.
export const CRYSTAL_WING_ASSET = {
  "url": "/models/crystal-wings/crystal-wings.glb",
  "hash": "6387f36f4410d9c5fd3f6b57df0fab0563c92880c791843cdcd4a4221f89d5f4"
} as const;
